import React from "react";
import "./Footer.css";
import logo from "../assets/logo.png";
import { FaLinkedin, FaYoutube, FaDiscord } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <div className="footer-line-wrapper">
        <hr className="footer-line" />
      </div>

      <footer className="site-footer">
        <div className="footer-left">
          <div className="footer-logo-wrapper">
            <img src={logo} alt="Logo" className="footer-logo" />
          </div>
        </div>

        <div className="footer-center">
          <p>© 2025 Sushe. All rights reserved.</p>
        </div>

        <div className="footer-right">
          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin />
          </a>
          <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
          <a href="https://www.discord.com/" target="_blank" rel="noopener noreferrer">
            <FaDiscord />
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
